// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3X5Qt","content":"LayoutSettings_content__25POk"};